import { notification } from 'antd';
import KeyIcon from 'icons/key.svg';
import React, { useState } from 'react';
import { localize } from '../../helpers';
import Button from '../button/button';

import './button-signature.scss';

const errorNotification = (message: string, description: string) => {
    const placement = 'topRight';
    notification.error({
        message,
        description,
        placement,
    });
};

interface Props {
    type?: 'button' | 'text' | string;
    onSubmit: any;
    onGetXml?: () => Promise<any>;
    children?: any;
    color?: string;
    disabled?: boolean | any;
    icon?: boolean;
    loading?: boolean;
    translations: Record<string, string>;
    signType?: 'AUTHENTICATION' | 'SIGN';
}

const Signature = ({
    type = 'button',
    onSubmit,
    onGetXml,
    children,
    color,
    disabled,
    icon = true,
    translations,
    signType = 'AUTHENTICATION',
}: Props) => {
    const [loading, setLoading] = useState(false);

    const signature = () => {
        setLoading(true);

        onGetXml()
            .then((xml: any) => {
                const webSocket = new WebSocket('wss://127.0.0.1:13579/');

                const signXml = {
                    module: 'kz.gov.pki.knca.commonUtils',
                    method: 'signXml',
                    args: ['PKCS12', signType, xml.data, '', ''],
                };

                webSocket.onopen = () => {
                    webSocket.send(JSON.stringify(signXml));
                };

                webSocket.onmessage = (event) => {
                    const result = JSON.parse(event.data);

                    if (result !== null && result.code === '200') {
                        onSubmit(result.responseObject);
                    }
                };

                webSocket.onclose = (event) => {
                    if (!event.wasClean) {
                        errorNotification(
                            localize('block-auth-connection-error', translations),
                            localize('block-auth-run-ncalayer', translations)
                        );
                    }
                };
            })
            .catch(() =>
                errorNotification(
                    localize('error', translations),
                    localize('block-auth-failed-xml', translations)
                )
            )
            .finally(() => setLoading(false));
    };

    return type === 'button' ? (
        <Button
            type="primary"
            color={color || 'gold'}
            icon={icon && <KeyIcon />}
            onClick={signature}
            disabled={disabled}
            loading={loading}
            className="button-signature"
        >
            {children || localize('block-auth-select-eds', translations)}
        </Button>
    ) : (
        <div onClick={signature}>{children || localize('block-auth-select-eds', translations)}</div>
    );
};

export default Signature;
